@if (!isSVG) {
    <img [src]="pictureId() ? contentString() : picture()" [attr.width]="width()" [attr.height]="height()" [style]="style()" />
} @else if (isSVG) {
    <div class="col-12 svg-preview" [innerHTML]="contentString() | safeHtml"></div>
}
